import { gql } from '@apollo/client'

export const GET_ALL_WATER_TRUCK_REQUEST_CONCILIATIONS = gql`
  query GetAllWaterTruckRequestConciliations(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filtersWaterTruckRequestConciliations
  ) {
    getAllWaterTruckRequestConciliations(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      count
      flags {
        isProvider
      }
      rows {
        id
        date_conciliation_start
        date_conciliation_end
        total_m3
        total_discharge_into_cisterns
        total_discharge_into_homes
        provider_id
        totalRequests
      }
    }
  }
`

export const CREATE_WATER_TRUCK_REQUEST_CONCILIATION = gql`
  mutation CreateWaterTruckRequestConciliation(
    $conciliationsIds: [Int!]!
    $dateConciliationEnd: String!
    $dateConciliationStart: String!
  ) {
    createWaterTruckRequestConciliation(
      conciliations_ids: $conciliationsIds
      date_conciliation_end: $dateConciliationEnd
      date_conciliation_start: $dateConciliationStart
    )
  }
`

export const EXPORT_TO_CSV_WATER_TRUCK_REQUEST_CONCILIATION = gql`
  mutation ExportToCsvWaterTruckRequestConciliationById($id: Int!) {
    ExportToCsvWaterTruckRequestConciliationById(id: $id) {
      id
      date_conciliation_start
      date_conciliation_end
      total_m3
      total_discharge_into_homes
      total_discharge_into_cisterns
      WaterTruckRequestConciliationToWaterRequest {
        id
        completed_at
        type_delivery
        volume
        folio
        createdAt
        is_extemporaneous
        comments
        priority
        ColonyOfWaterTruckRequest {
          id
          name
        }
        RoutesOfWaterTruckRequest {
          id
          truck_id
          user_id
          volume
          RouteToTrucks {
            id
            plate_number
            capacity
          }
          RouteToUser {
            id
            name
            first_name
            last_name
          }
        }
        AddressOfWaterTruckRequest {
          id
          street
          city
          address_full
        }
        StatusOfWaterTruckRequest {
          id
          name
        }
        RoutesPointsOfWaterTruckRequest {
          id
          water_truck_request_id
          loaded_at
          delivered_at
          createdAt
        }
        ProviderOfWaterTruckRequest {
          id
          card_name
          rfc
        }
        # TimelineOneWaterTruckRequest {
        #   id
        #   status_id
        # }
      }
    }
  }
`
export const EXPORT_TO_CSV_PREVIEW_WATER_TRUCK_REQUEST_CONCILIATION = gql`
  mutation ExportToCsvPreviewWaterTruckRequestConciliation(
    $dateConciliationStart: String!
    $dateConciliationEnd: String!
    $providerId: Int!
  ) {
    ExportToCsvPreviewWaterTruckRequestConciliation(
      date_conciliation_start: $dateConciliationStart
      date_conciliation_end: $dateConciliationEnd
      provider_id: $providerId
    ) {
      id
      completed_at
      type_delivery
      volume
      folio
      createdAt
      comments
      is_extemporaneous
      RoutesOfWaterTruckRequest {
        id
        truck_id
        user_id
        volume
        RouteToTrucks {
          id
          plate_number
          capacity
        }
        RouteToUser {
          id
          name
          first_name
          last_name
        }
      }
      AddressOfWaterTruckRequest {
        id
        street
        city
        address_full
      }
      StatusOfWaterTruckRequest {
        id
        name
      }
      RoutesPointsOfWaterTruckRequest {
        id
        water_truck_request_id
        loaded_at
        delivered_at
        createdAt
      }
      ProviderOfWaterTruckRequest {
        id
        card_name
        rfc
      }
      TimelineOneWaterTruckRequest {
        id
        status_id
      }
      ColonyOfWaterTruckRequest {
        id
        name
      }
    }
  }
`
